import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";

// Critical pages (loaded immediately)
import Home from "../pages/home/page";

// Lazy load non-critical pages
const SobreNos = lazy(() => import("../pages/SobreNos"));
const Contato = lazy(() => import("../pages/Contato"));
const Servico = lazy(() => import("../pages/Servico"));
const Privacy = lazy(() => import("../pages/Privacy"));
const ThankYou = lazy(() => import("../pages/ThankYou"));
const NotFound = lazy(() => import("../pages/NotFound"));

const withSuspense = (Component: React.ComponentType) => (
  <Suspense fallback={<div className="min-h-screen bg-white" />}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sobre-nos",
    element: withSuspense(SobreNos),
  },
  {
    path: "/contato",
    element: withSuspense(Contato),
  },
  {
    path: "/servico/:id",
    element: withSuspense(Servico),
  },
  {
    path: "/politica-de-privacidade",
    element: withSuspense(Privacy),
  },
  {
    path: "/obrigado",
    element: withSuspense(ThankYou),
  },
  {
    path: "*",
    element: withSuspense(NotFound),
  },
];

export default routes;
